



























import Vue from 'vue';
import VariableInput from '@/components/util/VariableInput.vue';
import FooterSimple from '@/parts/common/FooterSimple.vue';
import {
  mailAddressLengthLimit,
  mailAddressConstraintErrorMessage, 
  mailAddressRegExp,
} from '@/views/forms/constraint';
import { changeMailAddress } from '@/api/UserProfile';
import axios from 'axios';
import { ErrorResponse } from '@/api/dto/Error';

export default Vue.extend({
  name: 'CorpMailAddressChange',
  components: {
    VariableInput,
    FooterSimple,
  },
  watch: {
    'accountData.mail'(mailAddress: string) {
      this.inputs['mail'].error = (mailAddress.length <= mailAddressLengthLimit && mailAddressRegExp.test(mailAddress)) ? '' : mailAddressConstraintErrorMessage;
    },
  },
  data() {
    return {
      accountData: {
        mail: '',
      },
      inputs: {
        'mail': {name: 'メールアドレス', type: 'text', placeholder: '新しいメールアドレス', error: '' },
      },
      submitModal: false,
    }
  },
  computed: {
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return !(this.accountData.mail.length <= mailAddressLengthLimit && mailAddressRegExp.test(this.accountData.mail));
    },
  },
  methods: {
    async onClickSubmit() {
      this.submitModal = true;
      try{
      await changeMailAddress({
        newMailAddress: this.accountData.mail,
      });
      } catch(e) {
        if (axios.isAxiosError(e) && e.response) {
              var resError = e.response.data as ErrorResponse;
              if (resError.message != null) {
                this.$emit('errorToast', resError.message);
              }
        }
        return;
      }
      this.toAccountSettings();
      this.$emit('toast', 'メールアドレスを更新しました');
    },
    toAccountSettings() {
      this.$router.push({name:'AccountInfo'});
    },
  }
})
